import * as request from "../lib/lib";


const baseUrl = process.env.REACT_APP_BACKEND_URL + 'Parameter';

export const getParamsAdmin = async () => {
    const result = await request.get(`${baseUrl}/GetAllParametersAdmin`);

    return result;
}